import React, { useState, useEffect, useContext } from 'react';
import axios from '../../../hooks/axios';
import { normalizeTag } from '../../../utils/tagUtils';
import { UserContext } from '../../../hooks/UserContext';
import { HostInfoContext } from '../../../hooks/HostInfoContext';
import { CoverageTopic } from './CoverageTopic';
import { AccountInformation } from './AccountInformation';
import useLogout from '../../../hooks/useLogout';
import useAuth from '../../../hooks/useAuth';
import updateUserProfile from '../../../hooks/useUpdateUserProfile';
import { ContainerDiv, WrapperDiv, LeftHeadingDiv } from './Profile.Style';

export default function Profile() {
  const { setUserContext } = useAuth();
  const { updateProfileWithoutPush } = updateUserProfile();
  const { logoutUser } = useLogout();
  const { user } = useContext(UserContext);
  const hostInfo = useContext(HostInfoContext);
  const [allTags, setAllTags] = useState([]);
  const [userInput, setUserInput] = useState([]);

  const handleCheckboxClick = (tag) => {
    setUserInput((prevInput) =>
      prevInput.includes(tag)
        ? prevInput.filter((input) => input !== tag)
        : [...prevInput, tag]
    );
  };

  const StringToArray = (string) => {
    if (string) {
      return string.split(',');
    }
    return [];
  };

  useEffect(() => {
    const loadTags = async () => {
      try {
        const year = new Date().getFullYear();
        const response = await axios.get(`archive/?y=${year}&q=topics`);
        const topics = response.data?.topics || [];
        let normalizedTags = topics
          .map((topic) => {
            if (!topic) return null;
            if (typeof topic === 'string') return normalizeTag(topic);
            if (typeof topic === 'object' && topic.value) return normalizeTag(topic.value);
            return null;
          })
          .filter(Boolean)
          .filter((tag) => tag !== 'unknown');

        if (hostInfo?.STATE === 'HI') {
          normalizedTags = normalizedTags.filter(
            (icon) => !icon.startsWith('geo_')
          );
        }

        setAllTags(normalizedTags.map((icon) => ({ icon })));
      } catch (error) {
        console.error('Failed to load topic tags', error);
      }

      if (user) {
        let user_interests = StringToArray(
          user.user_interests?.toLowerCase() || ''
        );
        setUserInput(user_interests);
      }
    };

    loadTags();
  }, [user, hostInfo]);

  return (
    <WrapperDiv>
      <ContainerDiv>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <LeftHeadingDiv>{user?.name || 'Profile'}</LeftHeadingDiv>
          <button
            onClick={logoutUser}
            style={{
              background: '#0a819f',
              color: '#fff',
              border: 'none',
              borderRadius: '0.25rem',
              padding: '0.5rem 1rem',
              cursor: 'pointer',
              fontWeight: 700,
            }}
          >
            Sign Out
          </button>
        </div>

        <div>
          <AccountInformation
            updateProfileWithoutPush={updateProfileWithoutPush}
            user={user}
            setUserContext={setUserContext}
          />

          <CoverageTopic
            setUserContext={setUserContext}
            setUserInput={setUserInput}
            user={user}
            allTags={allTags}
            userInput={userInput}
            handleCheckboxClick={handleCheckboxClick}
          />
        </div>
      </ContainerDiv>
    </WrapperDiv>
  );
}
